import { render, staticRenderFns } from "./ProjectLayout.vue?vue&type=template&id=5c6188c2&"
import script from "./ProjectLayout.vue?vue&type=script&lang=js&"
export * from "./ProjectLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLayout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports